import { brushTypeToStrokeType } from "../../neosmartpen/pencomm/pencomm";
/** 2022/04/09
 *  NeoStroke 를 InkStoreStroke 로 변환 - june
 */
export function makeInkStoreStrokeFromNeoStroke(stroke) {
    // dot array를 binary로 바꾸어 base64 인코딩하는 부분
    const dotCount = stroke.dotArray.length;
    const dotPacketSize = 17;
    const dotBlob = new Uint8Array(dotPacketSize * stroke.dotCount);
    const view = new DataView(dotBlob.buffer);
    for (let i = 0, ln = dotCount; i < ln; i++) {
        const base = i * dotPacketSize;
        const dot = stroke.dotArray[i];
        view.setUint16(base + 0, dot.deltaTime, true);
        const force = dot.f;
        view.setFloat32(base + 2, force, true);
        view.setFloat32(base + 6, dot.x, true);
        view.setFloat32(base + 10, dot.y, true);
        view.setUint8(base + 14, 0); // tilt X
        view.setUint8(base + 15, 0); // tilt Y
        view.setUint8(base + 16, 0); // twist
    }
    let binary = "";
    for (let i = 0, ln = dotBlob.length; i < ln; i++) {
        binary += String.fromCharCode(dotBlob[i]);
    }
    const dotsBase64 = btoa(binary);
    // 잉크 스토어용 스트로크를 생성하는 부분
    const color = 0xff000000 | (parseInt(stroke.color.substr(-6), 16));
    const penTipType = 0;
    const strokeType = brushTypeToStrokeType(stroke.brushType);
    const retStroke = {
        strokeUUID: stroke.originalKey ? stroke.originalKey : stroke.key,
        version: 1,
        color,
        mac: stroke.mac,
        dotCount,
        penTipType,
        startTime: stroke.startTime,
        strokeType,
        thickness: stroke.thickness,
        updated: stroke.updated,
        deleteFlag: 0,
        writeId: stroke.writerId,
        dots: dotsBase64
    };
    return retStroke;
}
//# sourceMappingURL=InkstoreStroke.js.map